import React from 'react';
import Modal from 'react-modal';
import './QuantityPromptModal.css';

interface QuantityPromptModalProps {
    isOpen: boolean;
    eventName: string;
    onSelect: (quantity: string) => void;
    onSkip: () => void;
}

const quantityOptions = [
    { label: '1 Ticket', value: '1 Ticket' },
    { label: '2 Tickets', value: '2 Tickets' },
    { label: '3 Tickets', value: '3 Tickets' },
    { label: '4 Tickets', value: '4 Tickets' },
    { label: '5 Tickets', value: '5 Tickets' },
    { label: '6 Tickets', value: '6 Tickets' },
    { label: '7 Tickets', value: '7 Tickets' },
    { label: '8+ Tickets', value: '8+ Tickets' },
];

const QuantityPromptModal: React.FC<QuantityPromptModalProps> = ({ isOpen, eventName, onSelect, onSkip }) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onSkip}
            className='quantity-modal'
            overlayClassName='quantity-modal-overlay'
            ariaHideApp={false}
        >
            <div className='quantity-modal-content'>
                <div className='quantity-modal-title'>{eventName}</div>
                <div className='quantity-modal-subtitle'>How many tickets do you need?</div>
                <div className='quantity-modal-grid'>
                    {quantityOptions.map(option => (
                        <button
                            key={option.value}
                            className='quantity-modal-button'
                            onClick={() => onSelect(option.value)}
                        >
                            {option.label}
                        </button>
                    ))}
                </div>
                <div className='quantity-modal-guarantee'>
                    Selecting 2 or more tickets guarantees your seats will be together.
                </div>
                <button className='quantity-modal-skip' onClick={onSkip}>
                    Browse All Tickets
                </button>
            </div>
        </Modal>
    );
};

export default QuantityPromptModal;
